import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import {
  Table, Checkbox, Select, Divider,
} from 'antd';
import UserActions from '@Actions/userActions';
import Helpers from '@Apis/helpers';
import H3FormInput from '@Uilib/h3FormInput';
import MaskingPolicyActions from '@Actions/settings/maskingPolicyActions';
import SelectDepartment from '../../../../Common/SelectDepartment';
import documentUINamesConstant from '../../../../../apis/documentUINamesConstant';
import './style.scss';

class CreateRole extends Component {
  constructor(props) {
    super(props);
    const { user } = props;
    const documentUINames = documentUINamesConstant(user);

    this.state = {
      accessControlTableColumn: [
        {
          title: '',
          width: '160px',
          render: (text, record) => (<H3Text text={record[0]?.replaceAll('_', ' ')?.toProperCase()} className="org-pending-po__table-text" />),
        },
        {
          title: 'All Access',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Checkbox
                checked={
                  record[1]?.READ
                  && record[1]?.CREATE
                  && record[1]?.UPDATE
                  && record[1]?.DELETE
                }
                onChange={(e) => {
                  this.handleCheckChangeAll(e, record);
                }}
                //
                disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                  Helpers.permissionTypes.CREATE, user)}
              />
            );
          },
        },
        {
          title: 'Read',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Fragment>
                {
                  record[0]?.includes('dashboard') ? '' : (
                    <Checkbox
                      checked={record[1]?.READ}
                      onChange={(e) => this.handleCheckChange(e, record, 'READ')}
                      disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                        Helpers.permissionTypes.CREATE, user)}
                    />
                  )
                }
              </Fragment>
            );
          },
        },
        {
          title: 'Write',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Fragment>
                {
                  record[0]?.includes('dashboard') ? '' : (
                    <Checkbox
                      checked={record[1]?.CREATE}
                      onChange={(e) => this.handleCheckChange(e, record, 'CREATE')}
                      disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                        Helpers.permissionTypes.CREATE, user)}
                    />
                  )
                }
              </Fragment>
            );
          },
        },
        {
          title: 'Update',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Fragment>
                {
                  record[0]?.includes('dashboard') ? '' : (
                    <Checkbox
                      checked={record[1]?.UPDATE}
                      onChange={(e) => this.handleCheckChange(e, record, 'UPDATE')}
                      disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                        Helpers.permissionTypes.CREATE, user)}
                    />
                  )
                }
              </Fragment>
            );
          },
        },
        {
          title: 'Delete',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Fragment>
                {
                  record[0]?.includes('dashboard') ? '' : (
                    <Checkbox
                      checked={record[1]?.DELETE}
                      onChange={(e) => this.handleCheckChange(e, record, 'DELETE')}
                      disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                        Helpers.permissionTypes.CREATE, user)}
                    />
                  )
                }
              </Fragment>
            );
          },
        },
        {
          title: 'Costing',
          render: (text, record) => {
            const { user } = this.props;
            return (
              <Fragment>
                {
                  record[1]?.COSTING === null ? '' : (
                    <Checkbox
                      checked={record[1]?.COSTING}
                      onChange={(e) => this.handleCheckChange(e, record, 'COSTING')}
                      disabled={!Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
                        Helpers.permissionTypes.CREATE, user)}
                    />
                  )
                }
              </Fragment>
            );
          },
        },
      ],
      selectedPermissions: {
        tenant_role_name: '',
        product: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        price_list: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        inventory_indent: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        stock_transfer: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        delivery_challan: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        vendors: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        purchase_request: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        request_for_quotation: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        purchase_order: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        good_receiving: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        account_payable_invoice: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        debit_note: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        customer: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        sales_order: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        invoice: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        credit_note: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        customer_payments: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        workflow_setup: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        access_control_setup: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        user_management: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        vendor_payout: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        bill_of_material: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: false,
        },
        manufacturing_order: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: false,
        },
        factory_setup: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        quality_checks: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        quality_rules: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        expenses: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        e_way_bill: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        e_invoice: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        purchase_dashboard: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        inventory_dashboard: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        production_dashboard: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        sales_dashboard: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        reports: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        material_planning: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        sales_estimate: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        annual_maintenance_contract: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        return_slip: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        packing_slip: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        gate_document: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        vendor_price: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        consumption_order: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        purchase_indent: {
          READ: true,
          CREATE: false,
          UPDATE: false,
          DELETE: false,
          APPROVE: false,
          COSTING: null,
        },
        allow_all_access_to_so: false,
        allow_all_access_to_invoice: false,
        allow_all_access_to_estimate: false,
        editable_material_request_qty_from_mo: false,
        editable_work_order_qty: false,
        editable_material_request_qty_from_mrp: false,
        editable_purchase_order_qty: false,
      },
      typesOfPermissions: ['product', 'price_list', 'inventory_indent', 'stock_transfer', 'delivery_challan', 'vendors', 'purchase_request', 'request_for_quotation', 'purchase_order', 'good_receiving', 'account_payable_invoice', 'debit_note', 'bill_of_material', 'manufacturing_order', 'factory_setup', 'quality_checks', 'quality_rules', 'customer', 'sales_estimate', 'sales_order', 'packing_slip', 'invoice', 'credit_note', 'customer_payments', 'annual_maintenance_contract', 'return_slip', 'workflow_setup', 'access_control_setup', 'user_management', 'vendor_payout', 'expenses', 'e_way_bill', 'e_invoice', 'purchase_dashboard', 'inventory_dashboard', 'production_dashboard', 'sales_dashboard', 'reports', 'material_planning', 'gate_document', 'vendor_price', 'consumption_order', 'purchase_indent'],
      otherPermission: {
        allow_all_access_to_so: {
          uiName: `Make this user ${documentUINames.salesOrderUIName} Manager`,
          uiMessage: `When ${documentUINames.salesOrderUIName}s are restricted to assignee only, then only manager can see ${documentUINames.salesOrderUIName.toLowerCase()}.`,
        },
        allow_all_access_to_invoice: {
          uiName: 'Make this user Invoice Manager',
          uiMessage: 'When Invoices are restricted to assignee only, then only manager can see Invoice.',
        },
        allow_all_access_to_estimate: {
          uiName: `Make this user ${documentUINames.estimateUIName} Manager`,
          uiMessage: `When ${documentUINames.estimateUIName}s are restricted to assignee only, then only manager can see ${documentUINames.estimateUIName.toLowerCase()}.`,
        },
        editable_material_request_qty_from_mo: {
          uiName: 'Quantity editable while creating Material Request from Manfacturing Order.',
          uiMessage: "When Material Request is created from Manufacturing Order, the user will be able to enter Product's Quantity manually. Unchecking this option will make it non-editable.",
        },
        editable_work_order_qty: {
          uiName: 'Quantity editable while creating Work Order from Manfacturing Order.',
          uiMessage: "When Work Order is created from Manufacturing Order, the user will be able to enter Product's Primary and Secondary Quantities manually. Unchecking this option will make it non-editable.",
        },
        editable_material_request_qty_from_mrp: {
          uiName: 'Quantity editable while creating Material Request from Materials Planning.',
          uiMessage: "When Material Request is created from Materials Planning, the user will be able to enter Product's Quantity manually. Unchecking this option will make it non-editable.",
        },
        editable_purchase_order_qty: {
          uiName: 'Quantity editable while creating Purchase Order from Materials Planning.',
          uiMessage: "When Purchase Order is created from Materials Planning, the user will be able to enter Product's Quantity manually. Unchecking this option will make it non-editable.",
        },
        allow_to_change_product_batches_quality: {
          uiName: 'Allow this role to change product batches quality',
          uiMessage: 'When enabled, this role will be able to change product batches quality.',
        },
      },
    };
  }

  componentDidMount() {
  }

  handleCheckChange(e, record, field) {
    const { selectedPermissions } = this.state;
    const copyPermissions = JSON.parse(JSON.stringify(selectedPermissions));
    copyPermissions[record[0]][field] = !record[1]?.[field];
    this.setState({ selectedPermissions: copyPermissions });
  }

  handleCheckChangeAll(e, record) {
    const { selectedPermissions } = this.state;
    const copyPermissions = JSON.parse(JSON.stringify(selectedPermissions));
    copyPermissions[record[0]].READ = e.target.checked;
    copyPermissions[record[0]].CREATE = e.target.checked;
    copyPermissions[record[0]].UPDATE = e.target.checked;
    copyPermissions[record[0]].DELETE = e.target.checked;
    copyPermissions[record[0]].APPROVE = e.target.checked;
    if (copyPermissions[record[0]].COSTING !== null) copyPermissions[record[0]].COSTING = e.target.checked;
    this.setState({ selectedPermissions: copyPermissions });
  }

  handleOtherPermissionCheckChange(e, record) {
    const { selectedPermissions } = this.state;
    const copyPermissions = JSON.parse(JSON.stringify(selectedPermissions));
    copyPermissions[record[0]] = !record[1];
    this.setState({ selectedPermissions: copyPermissions });
  }

  render() {
    const {
      createRole, user,
      createRoleLoading, callback,
    } = this.props;
    const {
      accessControlTableColumn, typesOfPermissions,
      selectedPermissions, formSubmitted, otherPermission,
    } = this.state;
    return (
      <Fragment>
        <div className="create-role__slider" style={{ paddingBottom: '50px' }}>
          <div className="create-role__heading">
            <div className="ant-row">
              <div className="ant-col-md-12">
                <SelectDepartment
                  title="Select Department"
                  onChange={(value) => {
                    this.setState({
                      selectedPermissions: {
                        ...selectedPermissions,
                        tenant_department_name: value?.alias_name,
                        tenant_department_id: value?.tenant_department_id,
                        department_id: value?.department_id,
                      },

                    });
                  }}
                  customStyle={{
                    width: '98%',
                  }}
                  disabled={false}
                  containerClassName="orgInputContainer department__select"
                  labelClassName="orgFormLabel"
                  showError={formSubmitted && !selectedPermissions?.department_id}
                  noDropdownAlign
                  emptyNotAllowed
                  tenantId={user?.tenant_info?.tenant_id}
                />
              </div>
              <div className="ant-col-md-12">
                <H3FormInput
                  name="role name"
                  type="text"
                  containerClassName="orgInputContainer"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  placeholder=""
                  value={selectedPermissions?.tenant_role_name}
                  onChange={(e) => this.setState({
                    selectedPermissions: {
                      ...selectedPermissions,
                      tenant_role_name: e.target.value,
                    },
                  })}
                  label="Role Name"
                  maxlength="100"
                  disabled={createRoleLoading}
                  required
                  showError={formSubmitted && !selectedPermissions?.tenant_role_name}
                />
              </div>
            </div>

          </div>
          <div className="generic-table-container">
            <Table
              showHeader
              size="small"
              loading={createRoleLoading}
              pagination={false}
              columns={accessControlTableColumn}
              dataSource={selectedPermissions && Object.entries(selectedPermissions)?.filter((item) => typesOfPermissions.includes(item[0]))}
            // scroll={{ y: 'calc(100dvh - 230px)' }}
              scroll={{ y: 400 }}
              sticky
            />
          </div>
          <div className="other-permission-container">
            <Divider orientation="left" orientationMargin="0">Other Permissions</Divider>
            <div className="other-permission-line-container">
              {Object.entries(selectedPermissions)?.filter((item) => otherPermission[item[0]])?.map((record) => (
                <div key={record[0]} className="other-permission-line">
                  <Checkbox
                    checked={record[1]}
                    onChange={(e) => this.handleOtherPermissionCheckChange(e, record)}
                    disabled={createRoleLoading}
                  />
                  <H3Text text={otherPermission[record[0]].uiName} className="other-permission-line-label" infoMessage={otherPermission[record[0]].uiMessage ?? false} />
                </div>

              ))}
            </div>
          </div>
        </div>
        {Helpers.getPermission(Helpers.permissionEntities.ACCESS_CONTROL_SETUP,
          Helpers.permissionTypes.CREATE, user) && (
          <div className="create-role__footer">
            <H3Button
              text="Create Role"
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              disabled={createRoleLoading}
              isLoading={createRoleLoading}
              customClass="create-role__footer-submit"
              onClick={() => {
                this.setState({ formSubmitted: true });
                if (selectedPermissions.tenant_department_id) {
                  createRole({
                    ...selectedPermissions,
                    tenant_id: user?.tenant_info?.tenant_id,
                  }, () => {
                    callback();
                  });
                }
              }}
            />
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, TenantReducers, MaskingPolicyReducers,
}) => ({
  user: UserReducers.user,
  roles: UserReducers.roles,
  createRoleLoading: UserReducers.createRoleLoading,
  tenants: TenantReducers.tenants,
});

const mapDispatchToProps = (dispatch) => ({
  createRole: (payload, callback) => dispatch(
    UserActions.createRole(payload, callback),
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CreateRole));
